import React from "react";
import { useQuery } from "@apollo/client";
import Spinner from "components/base/Spinner";
import Errors from "components/base/Errors";
import Image from "components/base/Image";
import Button from "components/base/Button";
import { useModals } from "ModalProvider";
import { FETCH_LOGOS } from "./graphql";
import LogoFormModal from "./LogoFormModal";

function LogosGridView() {
  const { loading, error, data, refetch } = useQuery(FETCH_LOGOS);
  const modal = useModals();

  function openLogoForm(logo) {
    modal.present({
      maxWidth: "max-w-3xl",
      center: true,
      children: (
        <LogoFormModal logo={logo} refetch={refetch} hide={modal.hide} />
      ),
    });
  }

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  // group logos by category and sort active ones first
  const sortByActive = (logos) =>
    logos.sort((a, b) => (a.active === b.active ? 0 : a.active ? -1 : 1));

  const brandLogos = sortByActive(
    data.logos.filter((logo) => logo.category === "brand"),
  );
  const productLogos = sortByActive(
    data.logos.filter((logo) => logo.category === "product"),
  );
  const otherLogos = sortByActive(
    data.logos.filter(
      (logo) => logo.category !== "brand" && logo.category !== "product",
    ),
  );

  const renderLogoGrid = (logos) => (
    <div className="flex p-6 text-center gap-6 flex-wrap">
      {logos.map((i, index) => (
        <div key={index} className={i.active ? "" : "opacity-30"}>
          <div
            className="hover:scale-105 hover:cursor-pointer transition-transform"
            onClick={() => openLogoForm(i)}
          >
            <Image size="w-48 h-48" src={i.url} />
            <div className="pt-2 text-gray-500 text-xs break-all text-center">
              {i.name}
            </div>
          </div>
          {i.originFile && (
            <div className="pt-2 flex justify-center">
              <Button
                onClick={() => window.open(i.originFile, "_blank", "noopener")}
              >
                Download
              </Button>
            </div>
          )}
        </div>
      ))}
    </div>
  );

  return (
    <div className="space-y-8">
      {brandLogos.length > 0 && (
        <div>
          <div className="px-6 py-4 dark:bg-gray-800  dark:border-gray-700">
            <h2 className="text-lg font-semibold text-gray-700 dark:text-gray-300">
              Brand Logos
            </h2>
          </div>
          {renderLogoGrid(brandLogos)}
        </div>
      )}

      {productLogos.length > 0 && (
        <div>
          <div className="px-6 py-4 dark:bg-gray-800 dark:border-gray-700">
            <h2 className="text-lg font-semibold text-gray-700 dark:text-gray-300">
              Product Logos
            </h2>
          </div>
          {renderLogoGrid(productLogos)}
        </div>
      )}

      {otherLogos.length > 0 && (
        <div>
          <div className="px-6 py-4 dark:bg-gray-800 dark:border-gray-700">
            <h2 className="text-lg font-semibold text-gray-700 dark:text-gray-300">
              Other Logos
            </h2>
          </div>
          {renderLogoGrid(otherLogos)}
        </div>
      )}
    </div>
  );
}

export default LogosGridView;
